// Caché en sessionStorage con TTL — evita llamadas repetidas a StelOrder
// La caché se borra al cerrar el navegador; dentro de la sesión dura TTL_MS.

const TTL_MS = 5 * 60 * 1000; // 5 minutos
const PREFIX = 'apicache_';

export function getCached(key) {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (Date.now() - ts > TTL_MS) {
      sessionStorage.removeItem(PREFIX + key);
      return null;
    }
    return { data, ts };
  } catch { return null; }
}

export function setCached(key, data) {
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify({ data, ts: Date.now() }));
  } catch {} // ignorar errores de cuota
}

export function clearCached(key) {
  try { sessionStorage.removeItem(PREFIX + key); } catch {}
}

export function formatAge(ts) {
  if (!ts) return '';
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return `hace ${s}s`;
  return `hace ${Math.floor(s / 60)}min`;
}
